import { getErrorText } from '../notificationparsers/notificationdetails/detailsTextParsers/getErrorText';
import { getTradePlanUpdateText } from '../notificationparsers/notificationdetails/detailsTextParsers/getTradePlanUpdateText';
import { getWarningText } from '../notificationparsers/notificationdetails/detailsTextParsers/getWarningText';
import { getNotificationDetailsParser } from '../notificationparsers/notificationdetails/notificationDetailsParsers';

export function getNotificationType(notification) {
  const type = notification?.notificationDetails?.notificationType ?? 'TRADE_PLAN_UPDATE';
  const parsedDetails = getNotificationDetailsParser(notification.notificationDetails);
  let text = '';
  if (type === 'TRADE_PLAN_UPDATE') {
    text = getTradePlanUpdateText(parsedDetails);
  }
  if (type === 'WARNING') {
    text = getWarningText(parsedDetails);
  }
  if (type === 'ERROR') {
    text = getErrorText(parsedDetails);
  }
  return {
    type,
    text,
  };
}
